import { messages } from './messages';

export const MOVEMENT_INDICATORS = [
  {
    id: 'B2B',
    label: messages.B2B,
  },
  {
    id: 'B2C',
    label: messages.B2C,
  },
  {
    id: 'C2C',
    label: messages.C2C,
  },
  {
    id: 'C2B',
    label: messages.C2B,
  },
];
